import {useQuery} from "@tanstack/react-query";
import {readRmaDetailApi} from "../../../../api/support/RMA";

const useReadRmaDetail = (id: string) => {
    const {data} = useQuery({
        queryKey: ["readRmaDetail", id],
        queryFn: async () => await readRmaDetailApi({rmaId: Number(id)}),
        // staleTime: 1000 * 60,
        select: (res) => res?.result,
        retry: false,
        enabled: id !== undefined,
    });
    return {data};
};

export default useReadRmaDetail;
